import CommonReducer from "../CommonReducer";

const initialState = [];

const ReservationTaskReducer = CommonReducer(initialState, "reservationTask");

export default ReservationTaskReducer;
